export default "__VITE_ASSET__Cj8JKkb___"